export default {
    to: 'a',
    from: 'De',
    you: 'Você',
    prox: 'Prox',
    today: 'Hoje',
    future: 'Futuro',
    formattedToday: '(hoje) ',
    futureHoroscope: 'Horóscopo Futuro',
    
    link: {
        manageCharts: 'gerenciar-mapas',
        horoscopeUri: 'horoscopo-pessoal'
    },
    
    disclaimerCoronaVirus: {
        title: 'Importante!',
        seeGuideLink: 'Veja no nosso guia',
        covid19: 'Atente-se às recomendações dos órgãos de saúde durante a pandemia da Covid-19!',
        disclaimer: 'A astrologia é subjetiva e suas orientações são simbólicas e adaptáveis. <a onClick={onClickLink}>Veja no nosso guia</a> sobre como interpretar seu horóscopo no período atual.',
    },

    tabs: {
        seeOtherPerson: 'Ver o Horóscopo de outra pessoa'
    },

    mapSelector: {
        newChart: 'Criar Novo Mapa'
    },

    graphic: {
        imageNotFound: 'Imagem não encontrada'
    },

    frustration: {
        unlock: 'Desbloquear Recurso!',
        message: 'Seja premium e tenha acesso ao <br /> horóscopo dos seus mapas extras.'
    },

    frustrationFuture: {
        new: 'NOVO',
        influence: 'influência',
        influences: 'influências',
        unlock: 'Desbloquear Recurso!',
        incomingInfluences: '{subjectName} tem <strong>{actives}</strong> que se {textCount} nos próximos <strong>{qtdFutureDays} dias.</strong>',

        linkSeeAllBenefits: {
            clickHere: 'Clique aqui',
            checkAdvantages: ' e veja todas as vantagens de ser um usuário premium!'
        },

        willbeActive: {
            singular: 'se tornará ativa',
            plural: 'se tornarão ativas',
        },
    },

    influences: {
        futureDays: '{qtdFutureDays} dias',
        activeInfluence: '1 influência ativa',
        incomingInfluence: '1 influência se aproximando.',
        activeInfluences: '{countInfluences} influências ativas',
        desktopTitle: '{subjectName} tem&nbsp;<strong>{actives}</strong>',
        desktopTitleExraMap: '{subjectName} tem&nbsp;<strong>{actives}</strong>',
        incomingInfluences: '{countInfluences} influências se aproximando.',
        noIncomingInfluences: '<span>Não há <strong>influências</strong> se aproximando.</span>',
        noActiveInfluences: '<span> Não há <strong>influências ativas</strong> para hoje.</span>',
    },
    
    influencesItem: {
        readMore: 'Ler mais',
    },

    readMoreFuture: {
        incomingFutureYou: '<p>{subjectName} tem <strong>{countInfluences} {influence}</strong> entrando nos próximos <b>{QTD_FUTURE_DAYS} dias.</b></p>',
        incomingFutureThey: '<p>{subjectName} tem <strong>{countInfluences} {influence}</strong> entrando nos próximos <b>{QTD_FUTURE_DAYS} dias.</b></p>',
    }
};